import type { LegalLink } from '../types/content'

export const siteConfig = {
  brandName: 'L’Atelier du Faux Vitrail',
  price: '27 €',

  /** URL du paiement pour la France (confirmée par la propriétaire). */
  checkoutUrl: 'https://fauxvitrail.impultienda.ar/checkout/faux-vitrail',

  /**
   * Vidéo verticale (4:5) de la première section.
   * Vide = l’image du guide principal est affichée à la place.
   */
  heroVideoUrl: 'https://cdn.magicpatterns.com/uploads/mtNcZvneeEfuUXhTHscNW1/hero.mp4',

  /**
   * Preuve sociale confirmée par la propriétaire : note moyenne agrégée
   * et nombre de clientes (pas un nombre d’avis).
   */
  trust: {
    rating: 4.9 as number | null,
    customerLabel: 'Plus de 3\u00a0100 clientes nous font confiance',
  },

  /** Identifiant Meta Pixel du compte France (confirmé). Vide = non chargé. */
  metaPixelId: '2075627139735357',

  /**
   * Réponse FAQ « Comment recevoir les fichiers ? »
   * À rédiger selon le mode de livraison réel. Vide = question masquée.
   */
  deliveryAnswer: '',

  /**
   * Réponse FAQ « Puis-je vendre mes créations ? »
   * À rédiger selon les droits d’usage confirmés des modèles. Vide = question masquée.
   */
  commercialUseAnswer: '',

  /** Liens du pied de page. Seuls les liens avec une URL sont affichés. */
  legalLinks: [
    { label: 'Contact', href: '' },
    { label: 'Conditions générales de vente', href: '' },
    { label: 'Politique de confidentialité', href: '' },
    { label: 'Contenus numériques et droit de rétractation', href: '' },
  ] as LegalLink[],
}
